import React, { useState } from 'react';

const RatingInput = ({ id, onChange }) => {
  const [selectedRating, setSelectedRating] = useState(1);

  const handleRatingChange = (ratingValue) => {
    setSelectedRating(ratingValue);
    if (onChange) {
      onChange(ratingValue);
    }
  };

  return (
    <div>
        <div className="d-flex">
      {[1, 2, 3, 4, 5].map((ratingValue) => (
        <div className="form-check me-2" key={ratingValue}>
          <input
            className="form-check-input"
            type="radio"
            name={`rating_${id}`}
            id={`rating_${id}_${ratingValue}`}
            value={ratingValue}
            checked={selectedRating === ratingValue}
            onChange={() => handleRatingChange(ratingValue)}
          />
          <label className="form-check-label" htmlFor={`rating_${id}_${ratingValue}`}>
            {ratingValue}
          </label>
        </div>
      ))}
      </div>
    </div>
  );
};

export default RatingInput;
